var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8F9BB2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.278 15.4c2.54 0 4.61 2.016 4.718 4.544l.004.206v1.9c0 .525-.423.95-.944.95-.485 0-.884-.367-.939-.84l-.006-.11v-1.9c0-1.518-1.18-2.758-2.667-2.845l-.166-.005H4.722c-1.509 0-2.742 1.186-2.828 2.683l-.005.167v1.9c0 .525-.423.95-.945.95-.484 0-.883-.367-.938-.84L0 22.05v-1.9c0-2.554 2.004-4.638 4.517-4.746l.205-.004h7.556zM8.5 4c2.608 0 4.722 2.127 4.722 4.75S11.108 13.5 8.5 13.5c-2.608 0-4.722-2.127-4.722-4.75S5.892 4 8.5 4zm0 1.9c-1.565 0-2.833 1.276-2.833 2.85S6.935 11.6 8.5 11.6c1.565 0 2.833-1.276 2.833-2.85S10.065 5.9 8.5 5.9z",
    transform: "translate(-375 -2825) translate(0 2581) translate(375 240)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconContact);
export default __webpack_public_path__ + "static/media/user-icon-contact.f6dbe15fdf068016e3127d1d77f4c633.svg";
export { ForwardRef as ReactComponent };